import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import reviewPageActions from '../actions/reviewPage';
import actions from '../actions/actions';

// responds to 'GET_REVIEW_DETAILS' action
function getReviewMetadata(store) {
    request.get(`/${config.url_prefix}/api/getReviewMetadata?site=${store.getState().system.siteName}`)
        .end((error, response) => {
            if (error) {
                store.dispatch(reviewPageActions.alertError('internal.server.error'));
            } else {
                try {
                    const parsedResponse = JSON.parse(response.text);
                    if (!parsedResponse || parsedResponse.code >= 400) {
                        store.dispatch(reviewPageActions.alertError('ipmob.error.process.request'));
                    } else {
                        const siteName = store.getState().system.siteName;
                        store.dispatch(reviewPageActions.getReviewMetadataSuccess(parsedResponse, siteName));
                    }
                } catch (exp) {
                    store.dispatch(reviewPageActions.alertError('ipmob.error.process.request'));
                }
            }
            store.dispatch(actions.enableLoadOverLay(false));
        });
}
export default getReviewMetadata;
